import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import ChartContainer from './ChartContainer';

export default function PercentileBarChart({ data, title, loading, error, height = 400 }) {
  // Prepare data for chart
  const chartData = data?.map(item => ({
    name: item.label || item.metric,
    percentile: Math.round(item.percentile || 0),
    value: item.value
  })) || [];

  // Color based on percentile
  const getColor = (percentile) => {
    if (percentile >= 75) return '#10B981'; // Green
    if (percentile >= 25) return '#b1b1b1'; // Yellow
    return '#EF4444'; // Red
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-bg-light dark:bg-bg-dark border border-border-light dark:border-border-dark rounded-lg shadow-lg p-3">
          <p className="font-semibold text-text-primary-light dark:text-text-primary">
            {data.name}
          </p>
          <p className="text-sm text-text-secondary-light dark:text-text-secondary">
            Percentile: {data.percentile}%
          </p>
          {data.value !== undefined && (
            <p className="text-sm text-text-secondary-light dark:text-text-secondary">
              Value: {typeof data.value === 'number' ? data.value.toFixed(1) : data.value}
            </p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <ChartContainer title={title} loading={loading} error={error} height={height}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border-light dark:stroke-border-dark" />
          <XAxis
            dataKey="name"
            height={60} // Reduced from 80
            interval={0} // Forces all labels to show
            tick={{
              fontSize: 12,  // Makes text smaller
            }}
            angle={-45}
            textAnchor="end" // Key fix: anchors the 'end' of the text to the tick
            dx={-20} // Fine-tunes horizontal position
            dy={30}  // Fine-tunes vertical distance from axis
          />
          <YAxis
            label={{ value: 'Percentile', angle: -90, position: 'insideLeft' }}
            domain={[0, 100]}
            className="text-text-secondary-light dark:text-text-secondary"
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="percentile" radius={[8, 8, 0, 0]}>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getColor(entry.percentile)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
}
